import React from "react";
import BreadCrumb from "Common/BreadCrumb";
import withRouter from "Common/withRouter";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { User, Mail, Phone, Shield } from "lucide-react";

const UserProfile = () => {
  const selectAuth = createSelector(
    (state: any) => state.Login,
    (login) => ({ user: login.user })
  );
  const { user } = useSelector(selectAuth);

  const initials = `${user?.firstName?.[0] ?? "A"}${user?.lastName?.[0] ?? ""}`.toUpperCase();

  return (
    <React.Fragment>
      <BreadCrumb title="My Profile" pageTitle="Account" />

      <div className="max-w-xl">
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
          {/* Avatar + name */}
          <div className="flex items-center gap-4 px-6 py-5 border-b border-gray-100">
            <div className="w-14 h-14 rounded-full bg-indigo-100 flex items-center justify-center text-xl font-bold text-indigo-700 flex-shrink-0">
              {initials}
            </div>
            <div>
              <p className="text-base font-semibold text-gray-900">
                {user?.firstName} {user?.lastName}
              </p>
              <p className="text-sm text-gray-500">{user?.role ?? "Admin"}</p>
            </div>
          </div>

          {/* Details */}
          <div className="divide-y divide-gray-50 px-6">
            <div className="flex items-center gap-3 py-4">
              <Mail className="size-4 text-gray-400 flex-shrink-0" />
              <div>
                <p className="text-xs text-gray-400">Email</p>
                <p className="text-sm text-gray-800">{user?.email ?? "—"}</p>
              </div>
            </div>
            <div className="flex items-center gap-3 py-4">
              <Phone className="size-4 text-gray-400 flex-shrink-0" />
              <div>
                <p className="text-xs text-gray-400">Phone</p>
                <p className="text-sm text-gray-800">{user?.phoneNumber ?? "—"}</p>
              </div>
            </div>
            <div className="flex items-center gap-3 py-4">
              <Shield className="size-4 text-gray-400 flex-shrink-0" />
              <div>
                <p className="text-xs text-gray-400">Role</p>
                <p className="text-sm text-gray-800">{user?.role ?? "Admin"}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(UserProfile);
